// Reusable Electric Animations and Effects
export const electricAnimations = `
  @keyframes electric-pulse {
    0%, 100% {
      opacity: 0.6;
      transform: scale(1);
    }
    50% {
      opacity: 0.9;
      transform: scale(1.08);
    }
  }
  
  @keyframes electric-rotate {
    0% {
      background-position: 0% 50%;
      transform: rotate(0deg);
    }
    100% {
      background-position: 100% 50%;
      transform: rotate(360deg);
    }
  }
  
  /* Dotted circle border animations */
  @keyframes electric-rotate-idle {
    0% {
      transform: rotate(0deg);
      stroke-dashoffset: 0;
    }
    100% {
      transform: rotate(360deg);
      stroke-dashoffset: 20;
    }
  }
  
  @keyframes electric-rotate-anti {
    0% {
      transform: rotate(0deg);
      stroke-dashoffset: 0;
    }
    100% {
      transform: rotate(-360deg);
      stroke-dashoffset: -20;
    }
  }
  
  @keyframes electric-border-pulse {
    0%, 100% {
      stroke-width: 2px;
      opacity: 0.8;
    }
    50% {
      stroke-width: 3px;
      opacity: 1;
    }
  }
  
  @keyframes ai-icon-float {
    0%, 100% {
      transform: translateY(0px) scale(1);
      filter: drop-shadow(0 0 3px hsl(var(--cyan) / 0.6));
    }
    50% {
      transform: translateY(-3px) scale(1.08);
      filter: drop-shadow(0 0 6px hsl(var(--cyan) / 0.8));
    }
  }
  
  @keyframes icon-electric-pulse {
    0%, 100% {
    filter: drop-shadow(0 0 2px hsl(var(--cyan) / 0.3)) 
            drop-shadow(0 0 4px hsl(var(--emerald) / 0.2));
  }
  50% {
    filter: drop-shadow(0 0 3px hsl(var(--cyan) / 0.5)) 
            drop-shadow(0 0 6px hsl(var(--emerald) / 0.3));
  }
  }
  
  @keyframes icon-spin-slow {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes icon-spin-anti {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
  
  @keyframes spark-trail-1 {
    0% {
      transform: translate(0, 0) scale(1);
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    100% {
      transform: translate(-25px, -25px) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes spark-trail-2 {
    0% {
      transform: translate(0, 0) scale(1);
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    100% {
      transform: translate(25px, -25px) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes spark-trail-3 {
    0% {
      transform: translate(0, 0) scale(1);
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    100% {
      transform: translate(0, 30px) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes spark-trail-4 {
    0% {
      transform: translate(0, 0) scale(1);
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    100% {
      transform: translate(-15px, 20px) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes spark-trail-5 {
    0% {
      transform: translate(0, 0) scale(1);
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    100% {
      transform: translate(20px, 15px) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes spark-trail-6 {
    0% {
      transform: translate(0, 0) scale(1);
      opacity: 0;
    }
    20% {
      opacity: 1;
    }
    100% {
      transform: translate(-30px, 0) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes spark-burst {
    0% {
      transform: translate(0, 0) scale(0.5);
      opacity: 1;
    }
    100% {
      transform: translate(
        calc(cos(var(--angle)) * var(--distance) * 1px),
        calc(sin(var(--angle)) * var(--distance) * 1px)
      ) scale(0);
      opacity: 0;
    }
  }
  
  @keyframes module-spark-fade {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(0.5);
    }
  }
  
  @keyframes flow-gradient {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
    }
    100% {
      transform: translateX(100%) translateY(100%) rotate(45deg);
    }
  }
  
  @keyframes ripple {
    0% {
      transform: scale(0, 0);
      opacity: 0.5;
    }
    100% {
      transform: scale(20, 20);
      opacity: 0;
    }
  }
  
  /* Glow effect animations */
  @keyframes glow-pulse {
    0%, 100% {
      opacity: 0.3;
      transform: scale(1);
    }
    50% {
      opacity: 0.6;
      transform: scale(1.1);
    }
  }
  
  @keyframes glow-pulse-fast {
    0%, 100% {
      opacity: 0.4;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.15);
    }
  }

  @keyframes icon-rotate-3d {
    0% {
      transform: rotateY(0deg) scale(1);
    }
    50% {
      transform: rotateY(180deg) scale(0.9);
    }
    100% {
      transform: rotateY(360deg) scale(1);
    }
  }
  
  @keyframes glow-pulse-fast {
    0%, 100% {
      opacity: 0.4;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.15);
    }
  
  
  /* Border glow animations */
  @keyframes border-glow {
    0%, 100% {
      box-shadow: 0 0 5px hsl(var(--cyan) / 0.5),
                  0 0 10px hsl(var(--cyan) / 0.3),
                  inset 0 0 10px hsl(var(--cyan) / 0.2);
    }
    50% {
      box-shadow: 0 0 10px hsl(var(--cyan) / 0.8),
                  0 0 20px hsl(var(--cyan) / 0.5),
                  inset 0 0 15px hsl(var(--cyan) / 0.3);
    }
  }
`;

// Reusable helper functions for generating random data
export const generateModuleSparks = (count = 4) => {
  return Array.from({ length: count }).map((_, i) => ({
    id: i,
    size: Math.random() * 3 + 2,
    color: i % 2 === 0 ? "hsl(var(--cyan) / 0.8)" : "hsl(var(--emerald) / 0.8)",
    top: Math.random() * 100 + "%",
    left: Math.random() * 100 + "%",
    animationDelay: Math.random() * 0.5 + "s",
  }));
};

export const generateElectricSparks = (count = 6) => {
  return Array.from({ length: count }).map((_, i) => ({
    id: i,
    size: Math.random() * 4 + 2,
    color: i % 3 === 0 ? "hsl(var(--cyan))" : i % 3 === 1 ? "hsl(var(--emerald))" : "white",
    trail: `spark-trail-${i + 1}`,
  }));
};

export const generateBurstSparks = (count = 8) => {
  return Array.from({ length: count }).map((_, i) => {
    const angle = (i * 45) * (Math.PI / 180);
    const distance = 20 + Math.random() * 15;
    return {
      id: i,
      size: Math.random() * 4 + 1,
      color: i % 2 === 0 ? "hsl(var(--cyan))" : "hsl(var(--emerald))",
      angle: angle,
      distance: distance,
    };
  });
};

// Common gradient for all action buttons
export const commonGradient = "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))";
export const commonGradientHover = "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))";

// Size-specific gradients
export const smallButtonGradient = "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))";
export const mediumButtonGradient = "linear-gradient(135deg, hsl(var(--cyan)), hsl(var(--emerald)), hsl(var(--cyan)))";
export const largeButtonGradient = "linear-gradient(135deg, hsl(var(--cyan)), hsl(var(--emerald)), hsl(var(--cyan)), hsl(var(--emerald)))";

// Hover gradients
export const smallButtonGradientHover = "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))";
export const mediumButtonGradientHover = "linear-gradient(135deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9), hsl(var(--cyan) / 0.9))";
export const largeButtonGradientHover = "linear-gradient(135deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9), hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))";

// Button shadow presets
export const buttonShadows = {
  small: "0 2px 8px hsl(var(--cyan) / 0.3), 0 1px 3px hsl(var(--emerald) / 0.2)",
  medium: "0 4px 14px hsl(var(--cyan) / 0.35), 0 2px 6px hsl(var(--emerald) / 0.25)",
  large: "0 6px 20px hsl(var(--cyan) / 0.4), 0 3px 9px hsl(var(--emerald) / 0.3)",
};

export const buttonHoverShadows = {
  small: "0 4px 12px hsl(var(--cyan) / 0.4), 0 2px 5px hsl(var(--emerald) / 0.3)",
  medium: "0 6px 20px hsl(var(--cyan) / 0.45), 0 3px 8px hsl(var(--emerald) / 0.35)",
  large: "0 8px 25px hsl(var(--cyan) / 0.5), 0 4px 11px hsl(var(--emerald) / 0.4)",
};

// Helper functions for border styles
export const getBorderStyles = (size = "medium") => {
  const styles = {
    small: {
      strokeWidth: 1.5,
      dashArray: "2,2",
      dashOffset: 0,
      innerOffset: 1,
    },
    medium: {
      strokeWidth: 2,
      dashArray: "3,3",
      dashOffset: 0,
      innerOffset: 1.5,
    },
    large: {
      strokeWidth: 2.5,
      dashArray: "4,4",
      dashOffset: 0,
      innerOffset: 2,
    },
  };
  return styles[size] || styles.medium;
};

// Helper functions for animations
export const getButtonAnimations = (size = "medium") => {
  const isSmall = size === "small";
  return {
    rotateIdle: isSmall ? "electric-rotate-idle 6s linear infinite" : "electric-rotate-idle 4s linear infinite",
    rotateHover: isSmall ? "electric-rotate-anti 1.5s linear infinite" : "electric-rotate-anti 2s linear infinite",
    pulse: isSmall ? "electric-pulse 1.2s ease-in-out infinite" : "electric-pulse 1.5s ease-in-out infinite",
    iconFloat: isSmall ? "ai-icon-float 3s ease-in-out infinite" : "ai-icon-float 4s ease-in-out infinite",
  };
};

// Gradient generator helper
export const generateButtonGradient = (size = "medium", isHover = false) => {
  const gradients = {
    small: isHover ? smallButtonGradientHover : smallButtonGradient,
    medium: isHover ? mediumButtonGradientHover : mediumButtonGradient,
    large: isHover ? largeButtonGradientHover : largeButtonGradient,
  };
  return gradients[size] || gradients.medium;
};

// Border gradient
export const generateBorderGradient = () => {
  return `linear-gradient(90deg, 
    hsl(var(--cyan)) 0%,
    hsl(var(--cyan) / 0.8) 25%,
    hsl(var(--emerald)) 50%,
    hsl(var(--emerald) / 0.8) 75%,
    hsl(var(--cyan)) 100%)`;
};